import { FormControl } from '@angular/forms';

export class FormUtils {
  static compareDates(firstDate: FormControl<string | null>, lastDate: FormControl<string | null>, includeEqual = true, noValidationNullable = false) {
    let dataInicio: Date | null = null;
    let dataTermino: Date | null = null;

    function applyValidation(referenceDate: Date | null) {
      if (referenceDate === null) {
        FormUtils.setDateError(firstDate, null);
        FormUtils.setDateError(lastDate, null);
        return;
      }

      const isValid = includeEqual
                      ? FormUtils.moreEqualThan(dataInicio, dataTermino)
                      : FormUtils.moreThan(dataInicio, dataTermino);

      FormUtils.setDateError(firstDate, isValid ? null : "Data inicial não pode ser maior que a data final.");
      FormUtils.setDateError(lastDate, isValid ? null : "Data final não pode ser menor que a data inicial.");
    }

    firstDate.valueChanges.subscribe((date) => {
      if (noValidationNullable) return;
      dataInicio = date ? new Date(date) : null;

      applyValidation(dataTermino);
    });

    lastDate.valueChanges.subscribe((date) => {
      if (noValidationNullable) return;
      dataTermino = date ? new Date(date) : null;

      applyValidation(dataInicio);
    });
  }

  private static setDateError(control: FormControl<string | null>, message: string | null): void {
    const errors = { ...control.errors };

    if (message) {
      errors['TextError'] = message;
    } else {
      delete errors['TextError'];
    }

    control.setErrors(Object.keys(errors).length ? errors : null);
  }

  private static moreEqualThan(firstDate: Date | null, lastDate: Date | null): boolean {
    return firstDate !== null && lastDate !== null && lastDate >= firstDate;
  }

  private static moreThan(firstDate: Date | null, lastDate: Date | null): boolean {
    return firstDate !== null && lastDate !== null && lastDate > firstDate;
  }
}
